"use client";

import { useContent } from "../../content/current";
import LegalContent from "./LegalContent";

export default function AvisoLegalContent() {
  const content = useContent();
  return <LegalContent html={content.legalPages.aviso.html} />;
}
